import { action } from 'satcheljs';

export const onNewReportClicked = action('onNewReportClicked');
